// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lprt","clinicsSelect":"styles_clinicsSelect__1AIH2"};